import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styles from "../../Components/Bookings/Bookings.module.css";
import upArrow from "../../Images/up.png";
import downArrow from "../../Images/down.png";
import offerImg from "../../Images/offer.png";
import BillLine from "../../Components/Bookings/BillLine";
import { useSelector, useDispatch } from "react-redux";
import {
  checkExpiredService,
  getReservationPackage,
  getServicesReservationFromPackage,
  getStoppedPackage,
  resumePackage,
  stopPackage,
} from "../../redux/Slices/reservation/thunk";
import Modal from "react-bootstrap/Modal";
import { getPackageServices } from "../../redux/Slices/Packages/thunk";
import { Button, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import notify from "../Utilities/notify";
import Logo from "../../Images/Logo.png";
import image1 from "../../Images/noimage.jpeg";

export default function BookBaqa({ toggleShow, setPackageLength }) {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const isArabic = currentLanguage === "ar";
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const {
    ReservationPackage,
    loading,
    servicesReservationFromPackage,
    isLoading,
    ServiceStatus,
    stoppedPackage,
  } = useSelector((state) => state.reservationSlice);
  const { settings } = useSelector((state) => state.usersSlice);
  const { PackageServices } = useSelector((state) => state.PackagesSlice);
  const { PackageServicesLoading } = useSelector(
    (state) => state.reservationSlice
  );
  const [isLoadingStatic, setIsLoadingStatic] = useState(null);
  const [isFroozingLoading, setIsFroozingLoading] = useState(null);
  const [showFreezeModel, setShowFreezeModel] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [startFreezeTime, setStartFreezeTime] = useState();
  const [endFreezeTime, setEndFreezeTime] = useState();
  const [freezeNotes, setFreezeNotes] = useState();
  const [isLoadingStatic2, setIsLoadingStatic2] = useState(false);
  const [isLoadingStop, setIsLoadingStop] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showCancelModel, setShowCancelModel] = useState(false);
  const [header, setHeader] = useState();
  const [header2, setHeader2] = useState();
  console.log("ReservationPackage", ReservationPackage);
  console.log("PackageServices", PackageServices);
  console.log("servicesReservationFromPackage", servicesReservationFromPackage);
  console.log("settings", settings);

  const [openServiceId, setOpenServiceId] = useState(null);

  let ToDay = new Date();
  let formattedToDay = ToDay.toISOString().split("T")[0];
  const labelStyle = {
    fontWeight: "bold",
    marginRight: isArabic ? "0px" : "10px",
    marginLeft: isArabic ? "10px" : "0px",
    display: "inline-block",
    color: "#B49345",
  };
  const toggleItem = (id) => {
    setOpenServiceId((prevId) => (prevId === id ? null : id));
  };

  const [openInvoiceId, setOpenInvoiceId] = useState(null);

  const toggleInvoice = (id) => {
    setOpenInvoiceId((prevId) => (prevId === id ? null : id));
  };

  const onServicesOpen = async (index) => {
    await dispatch(
      getServicesReservationFromPackage({
        id: ReservationPackage[index]?.serviceHeader?.ith_key,
      })
    );
  };

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getReservationPackage({ id: user?.cln_key }));
  }, []);

  const openModal = async (reservation) => {
    console.log("reservation", reservation);
    await dispatch(getPackageServices({ Id: reservation }));
    setIsLoadingStatic(null);
    setIsModalOpen(true);
  };
  const closeModal = () => setIsModalOpen(false);

  console.log("stoppedPackage", stoppedPackage);

  const createInvoiceHTML = (reservation) => {
    const direction = isArabic ? "rtl" : "ltr";
    const lang = isArabic ? "ar" : "en";

    return `
      <!DOCTYPE html>
    <html lang="${lang}" dir="${direction}">
        <head>
          <meta charset="utf-8">
          <title>Invoice</title>
          <style>
            body {
              font-family: Cairo;
              margin: 20px;
              direction: ${direction};
              text-align: ${isArabic ? "right" : "left"};
              font-size: 13px;

            }
            .invoice-container {
                   max-width: 800px;
                   margin: auto;
                   padding: 20px;
                   text-align: center; 
                   position: relative;
                   }
                    .clientContainer {
                   max-width: 800px;
                   margin: auto;
                   padding: 10px;
                   padding-top: 20px;
                   text-align: center; /* Centers text inside */
                   position: relative;
                   }
                .invoice-title {
                position: absolute;
                top: -25px; /
                left: ${isArabic ? "" : "20%"};
                right: ${isArabic ? "-30px" : ""};
                transform: translateX(-50%);
                background: white;
                padding: 0 10px;
                font-size: 18px;
                font-weight: bold;
                border: 1px solid #000;
                background-color: #d1d1d1;
                font-size: 13px;
                }

              .header {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
              }

              .logo-container {
                display: flex;
                justify-content: center;
                position: relative;
                top: -10px; 
              }

              .logo-container img {
                height: 120px;
                width: auto;
              }
            .header h2 {
              margin: 0 0 10px;
               text-align: ${isArabic ? "right" : "left"};
            }
            .header p {
              margin: 4px 0;
               text-align: ${isArabic ? "right" : "left"};
               font-size: 12px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 20px;
            }
            table, th, td {
              border: 1px solid #000;
            }
            td{
            font-size: 12px;
            }
            th, td {
              padding: 8px;
              text-align: left;
              text-align: ${isArabic ? "right" : "left"};
            }
            th {
              background-color: #d1d1d1;
              font-size: 13px;
            }
            .section-title {
              background-color: #d1d1d1;
              padding: 10px;
              font-weight: bold;
              margin-bottom: 10px;
              font-size: 13px;
            }
          </style>
        </head>
        <body>
          <div class="invoice-container">
               <div class="clientContainer" style="display: flex; align-items: center; justify-content: space-between;  border: 1px solid #000;">
              <!-- Title Section -->
              <h2 class="invoice-title">${t("client_data")}</h2>

              <!-- Header Section -->
              <div class="header">
                <p> ${t("Client ID")}: ${
      reservation?.serviceHeader?.ith_custL4
    }</p>
                <p>${t("Client Name")}: ${user?.cln_username}</p>
                <p>${t("email")}: ${user?.cln_email}</p>
                <p>${t("phoneNumber")}: ${user?.cln_mobl}</p>
              </div>

              <!-- Logo Section -->
              <div class="logo-container">
                <img src="${Logo}" alt="Logo">
              </div>
            </div>
                  <br />

            
            <!-- Package Details -->
            <div class="section">
              <table>
                <tr>
                    <th colspan="5" style="text-align: center; height:35px;" >${t(
                      "packageDetails"
                    )}</th>
                    </tr>

                <tr>
                  <td style="text-align: center; width:20%; ">${t(
                    "packageName"
                  )}</td>
                  <td style="text-align: center; width:80%; ">${
                    isArabic
                      ? reservation?.serviceHeader?.ith_pac_nam
                      : reservation?.serviceHeader?.ith_pac_enm
                  }</td>
                </tr>
                <tr>
                  <td style="text-align: center; width:20%; ">${t(
                    "PackageStartDate"
                  )}</td>
                  <td style="text-align: center; width:80%; ">${
                    reservation?.serviceHeaderDetails?.from_dat
                  }</td>
                </tr>
                <tr>
                  <td style="text-align: center; width:20%; ">${t(
                    "PackageEndDate"
                  )}</td>
                  <td style="text-align: center; width:80%; ">${
                    reservation?.serviceHeaderDetails?.to_dat
                  }</td>
                </tr>
                <tr>
                  <td style="text-align: center; width:20%; ">${t(
                    "duration"
                  )}</td>
                  <td style="text-align: center; width:80%; ">${
                    reservation?.serviceHeaderDetails?.itm_dscnt
                  } ${t("day2")}</td>
                </tr>
               
              </table>
            </div>
           
            <!-- Package Services Table -->
            <div class="section">
              ${
                reservation?.serviceDetails &&
                reservation?.serviceDetails?.length > 0
                  ? `
                    <table>
                      <tr>
                        <th  colspan="5" style="text-align: center; height:35px" >${t(
                          "Package Services"
                        )}</th>
                      </tr>
                      <tr>
                        <th style="text-align: center;  width:20%;  ">${t(
                          "Quantity"
                        )}</th>
                        <th style="text-align: center;  width:80%;  ">${t(
                          "Service Name"
                        )}</th>

                      </tr>
                      ${reservation?.serviceDetails
                        .map(
                          (service) => `
                        <tr>

                          <td style="text-align: center; ">${
                            service?.itd_totqty
                          }</td>
                             <td style="text-align: center; ">${
                               isArabic
                                 ? service?.itd_itm_nam
                                 : service?.itd_itm_enm
                             }</td>
                        </tr>
                      `
                        )
                        .join("")}
                    </table>
                  `
                  : `<p>${t("No services available")}</p>`
              }

                 <!-- Invoice Details Table -->
            <div class="section">
              <table>
                   <tr>
                    <th colspan="5" style="text-align: center; height:35px;" >${t(
                      "Invoice Details"
                    )}</th>
                    </tr>
                <tr>
                  <td style="text-align: center; width:50%; ">${t(
                    "paymentType"
                  )}</td>
                  <td style="text-align: center; width:50%; ">${
                    reservation?.serviceHeader?.ith_payM == 1
                      ? t("cash")
                      : t("online")
                  }</td>
                </tr>
                <tr>
                  <td style="text-align: center; width:50%; ">${t(
                    "totalIncludingTax"
                  )}</td>
                  <td style="text-align: center; width:50%; ">${Number(
                    reservation?.serviceHeader?.ith_totalamount
                  ).toFixed(2)} ${t("rs")}</td>
                </tr>
                <tr>
                  <td style="text-align: center; width:50%; ">${t(
                    "Added Value Tax"
                  )}</td>
                  <td style="text-align: center; width:50%; ">${Number(
                    reservation?.serviceHeader?.ith_TXTS
                  ).toFixed(2)} ${t("rs")}</td>
                </tr>
                <tr>
                  <td style="text-align: center; width:50%; ">${t(
                    "Discount Coupon"
                  )}</td>
                  <td style="text-align: center; width:50%; ">${Number(
                    reservation?.serviceHeader?.ith_dscntV
                  ).toFixed(2)} ${t("rs")}</td>
                </tr>
                <tr>
                  <td style="text-align: center; width:50%; ">${t(
                    "Loyal Points"
                  )}</td>
                  <td style="text-align: center; width:50%; ">${Number(
                    reservation?.serviceHeader?.ith_PayMVal2
                  ).toFixed(2)} ${t("rs")}</td>
                </tr>
                <tr>
                  <th style="text-align: center; width:50%; ">${t("Total")}</th>
                  <th style="text-align: center; width:50%; ">${(
                    Number(reservation?.serviceHeader?.ith_totalamount) -
                    Number(reservation?.serviceHeader?.ith_dscntV) -
                    Number(reservation?.serviceHeader?.ith_PayMVal2)
                  ).toFixed(2)} ${t("rs")}</th>
                </tr>
              </table>
            </div>
            
            </div>
          </div>
        </body>
      </html>
    `;
  };

  const handlePrint = async (reservation) => {
    try {
      // Await the package services data and unwrap it (if using Redux Toolkit)
      // setIsLoadingStatic2(true);
      // const packageServicesData = await dispatch(
      //   getPackageServices({ Id: reservation?.serviceDetails[0]?.itd_itm })
      // ).unwrap();

      // setIsLoadingStatic2(false);

      // Now generate the HTML using the fetched data.
      const invoiceHTML = createInvoiceHTML(reservation);

      // Open a new window and write the HTML content
      const printWindow = window.open("", "", "width=800,height=600");
      printWindow.document.write(invoiceHTML);
      printWindow.document.close(); // necessary for IE >= 10
      printWindow.focus();
      printWindow.print();
      // Optionally, close the window after printing:
      // printWindow.close();
    } catch (error) {
      console.error("Error fetching package services:", error);
    }
  };
  if (ReservationPackage) {
    setPackageLength(ReservationPackage?.length);
  }

  const calculateDaysOfFreeze = (start, end) => {
    if (!start || !end) return "0";
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffTime = endDate - startDate;
    return diffTime > 0 ? Math.ceil(diffTime / (1000 * 60 * 60 * 24)) : "0";
  };

  const stopPackageSubmit = async () => {
    try {
      if (isLoadingStop) return;
      console.log("header2", header2);
      const freezeDays = calculateDaysOfFreeze(startFreezeTime, endFreezeTime);
      const totalStoppedDays = stoppedPackage.reduce(
        (sum, pkg) => sum + pkg.number_of_days,
        0
      );
      const totalDays = freezeDays + totalStoppedDays;
      const maxAllowedDays = Number(header2?.max_stop_pack);
      const hasActiveStopPackage = stoppedPackage.find(
        (pkg) => pkg.status === true
      );
      const today = new Date();
      today.setHours(0, 0, 0, 0); // يصفر الوقت تمامًا

      const selectedDate = new Date(startFreezeTime);
      selectedDate.setHours(0, 0, 0, 0);

      console.log(
        "maxAllowedDays",
        maxAllowedDays,
        "-------",
        "freezeDays",
        freezeDays,
        "---------",
        "totalStoppedDays",
        totalStoppedDays
      );

      if (hasActiveStopPackage)
        return notify(
          t("can'tStopPackageWhileYouHaveActiveStopPackage"),
          "error"
        );
      if (!startFreezeTime || !endFreezeTime)
        return notify(t("selectFreezeDates"), "error");
      if (freezeDays <= 0) return notify(t("invalidDateRange"), "error");
      if (maxAllowedDays <= totalDays)
        return notify(t("maxStopDaysExceeded"), "error");
      if (
        new Date(startFreezeTime) <
        new Date(header2?.from_dat.trim().replace(/\//g, "-"))
      )
        return notify(t("freezeStartTooEarly"), "error");
      if (selectedDate < today) {
        return notify(t("freezeStartTooEarlyFromNow"), "error");
      }
      if (
        new Date(endFreezeTime) >
        new Date(header2?.to_dat.trim().replace(/\//g, "-"))
      )
        return notify(t("freezeEndTooLate"), "error");
      console.log(
        "header2?.from_dat.replace(///g, '-')",
        new Date(header2?.from_dat.trim().replace(/\//g, "-"))
      );
      console.log(
        "header2?.from_dat.replace(///g, '-')",
        header2?.from_dat.trim().replace(/\//g, "-")
      );
      console.log("Date(startFreezeTime)", new Date(startFreezeTime));
      console.log(
        "Date(startFreezeTime) < Date(header2?.from_dat.replace(///g, '-'))",
        new Date(startFreezeTime) <
          new Date(header2?.from_dat.trim().replace(/\//g, "-"))
      );

      const data = {
        formDate: startFreezeTime,
        toDate: endFreezeTime,
        numOfDays: freezeDays,
        notes: freezeNotes,
        packageId: header2?.itd_itmsrl,
        ithKey: header2?.itd_key,
      };
      console.log("data", data);
      // return;
      setIsLoadingStop(true);
      setShowFreezeModel(false);
      const response = await dispatch(
        stopPackage({
          id: header2?.itd_num,
          data: data,
        })
      );

      if (response.error) {
        throw new Error(response.error.message);
      }

      notify(t("serviceFrozen"), "success");
      await dispatch(getReservationPackage({ id: user?.cln_key }));
      setIsLoadingStop(false);
    } catch (error) {
      console.error("Stop package failed:", error);
      setIsLoadingStop(false);

      notify(t("stopPackageFailed"), "error");
    }
  };

  const handleCloseModal = () => {
    setShowFreezeModel(false);
    setShowDetails(false);
    setStartFreezeTime("");
    setEndFreezeTime("");
    setFreezeNotes("");
  };
  const resumePackageSubmit = async () => {
    if (!header?.ith_num || !header?.ith_key) {
      // Optionally handle missing data
      notify(t("resumePackageError"), "error");
      return;
    }

    try {
      setIsLoadingStop(true);
      setShowFreezeModel(false);

      const data = {
        ith_key: header.ith_key,
      };

      // If you use Redux Toolkit createAsyncThunk, you can unwrap to catch errors:
      await dispatch(resumePackage({ id: header2.itd_num, data })).unwrap();
      notify(t("resumePackageSuccess"), "success");

      // Refresh reservation packages
      if (user?.cln_key) {
        await dispatch(getReservationPackage({ id: user.cln_key })).unwrap();
      }
    } catch (err) {
      console.error("Error resuming package:", err);
      // You may inspect err.message or a response to show more details
      notify(t("resumePackageError"), "error");
    } finally {
      setIsLoadingStop(false);
    }
  };
  return (
    <>
      {PackageServicesLoading ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Spinner
            animation="border"
            role="status"
            style={{ width: "100px", height: "100px" }}
          />
        </div>
      ) : (
        <div>
          {ReservationPackage?.length > 0 ? (
            <div>
              {ReservationPackage.map((reservation, index) => (
                <div
                  key={index}
                  className={`mx-auto ${styles.box}  my-3`}
                  style={{ background: "#fff" }}
                >
                  <div className="d-flex justify-content-between p-2 flex-wrap">
                    <div style={{ width: "100px" }}>
                      {reservation?.serviceHeader?.ith_num}
                    </div>
                    <div
                      className="d-flex justify-content-center align-items-center mx-2"
                      style={{ width: "100px" }}
                    >
                      {" "}
                      <img
                        id="billImg"
                        onClick={() => {
                          toggleInvoice(reservation?.serviceHeader?.ith_num);
                          toggleItem(reservation?.serviceHeader?.ith_num);
                          onServicesOpen(index);
                        }}
                        src={
                          openInvoiceId === reservation?.serviceHeader?.ith_num
                            ? downArrow
                            : upArrow
                        }
                        alt=""
                      />
                    </div>
                    <div style={{ width: "100px" }}>
                      {reservation?.serviceHeaderDetails?.from_dat}{" "}
                    </div>
                  </div>

                  <div
                    className={`${styles.offerBox} m-2 bg-liteGray `}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <div
                      className={`m-2 d-flex justify-content-between align-items-center flex-wrap`}
                    >
                      <div className={styles.imageBox}>
                        <img
                          src={
                            reservation?.serviceHeader?.ith_pac_IMG &&
                            reservation?.serviceHeader?.ith_pac_IMG?.trim() !=
                              ""
                              ? `https://reservation.ladycaresa.com/public/uploads${reservation?.serviceHeader?.ith_pac_IMG}`
                              : image1
                          }
                          //   ? reservation?.serviceHeader?.ith_pac_IMG
                          //   :
                          // offerImg

                          alt=""
                          style={{
                            width: "50px",
                            border: "1px solid #B49345",
                            borderRadius: "8px",
                          }}
                        />
                      </div>
                      <h5 className="my-auto">
                        {isArabic
                          ? reservation?.serviceHeader?.ith_pac_nam
                          : reservation?.serviceHeader?.ith_pac_enm}
                      </h5>
                    </div>

                    <div
                      className={` m-2 d-flex justify-content-between align-items-center flex-wrap`}
                    >
                      <div className="my-auto smallFont">
                        <span>{t("startDate")} : </span>
                        <span>
                          {reservation?.serviceHeaderDetails?.from_dat}{" "}
                        </span>
                      </div>
                      <div className="my-auto smallFont">
                        <span>{t("EndDate")} : </span>
                        <span>
                          {reservation?.serviceHeaderDetails?.to_dat}{" "}
                        </span>
                      </div>
                    </div>
                  </div>

                  {openInvoiceId === reservation?.serviceHeader?.ith_num && (
                    <>
                      <div
                        id="bill"
                        className={`${styles.billBox} m-2 bg-liteGray`}
                      >
                        <div className="m-2">
                          <div className={`${styles.titleBill}`}>
                            {t("Bill")}{" "}
                          </div>

                          <BillLine
                            text1={t("paymentType")}
                            text2={
                              reservation?.serviceHeader?.ith_payM == 1
                                ? t("cash")
                                : t("online")
                            }
                            styles={styles}
                            myClass="my-3 justify-content-between"
                          />
                          <BillLine
                            text1={t("totalIncludingTax")}
                            text2={`${(
                              Number(
                                reservation?.serviceHeader?.ith_totalamount
                              ) + Number(reservation?.serviceHeader?.ith_dscntV)
                            ).toFixed(2)} ${t("rs")}`}
                            styles={styles}
                            myClass="my-3 justify-content-between"
                          />
                          <BillLine
                            text1={t("Added Value Tax")}
                            text2={`${Number(
                              reservation?.serviceHeader?.ith_TXTS
                            )?.toFixed(2)} ${t("rs")}`}
                            styles={styles}
                            myClass="my-3 justify-content-between"
                          />
                          <BillLine
                            text1={t("Discount Coupon")}
                            text2={`${Number(
                              reservation?.serviceHeader?.ith_dscntV
                            )?.toFixed(2)} ${t("rs")}`}
                            styles={styles}
                            myClass="my-3 justify-content-between"
                          />
                          <BillLine
                            text1={t("Loyal Points")}
                            text2={`${Number(
                              reservation?.serviceHeader?.ith_PayMVal2
                            )?.toFixed(2)} ${t("rs")}`}
                            styles={styles}
                            myClass="my-3 justify-content-between"
                          />
                          <BillLine
                            text1={t("Total")}
                            text2={`${(
                              Number(
                                reservation?.serviceHeader?.ith_totalamount
                              )?.toFixed(2) -
                              Number(reservation?.serviceHeader?.ith_PayMVal2)
                            ).toFixed(2)} ${t("rs")}`}
                            styles={styles}
                            myClass="my-3 justify-content-between"
                          />

                          <div
                            className="d-flex justify-content-between mt-4"
                            style={{ gap: "10px" }}
                          >
                            <button
                              className={styles.button}
                              onClick={() => handlePrint(reservation)}
                              disabled={isLoadingStatic2}
                              style={{ width: "100%" }}
                            >
                              {isLoadingStatic2 ? <Spinner /> : t("Print")}
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className={`${styles.billBox} m-2 bg-liteGray`}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            margin: "12px",
                          }}
                        >
                          {servicesReservationFromPackage?.length > 0 && (
                            <div className={`${styles.titleBill} my-4`}>
                              {t("services")}{" "}
                            </div>
                          )}
                          {servicesReservationFromPackage?.length > 0 && (
                            <div className="my-auto">
                              <img
                                id="serviceImg"
                                onClick={() => {
                                  toggleItem(
                                    reservation?.serviceHeader?.ith_num
                                  );
                                  // onServicesOpen(index);
                                }}
                                src={
                                  openServiceId ===
                                  reservation?.serviceHeader?.ith_num
                                    ? downArrow
                                    : upArrow
                                }
                                alt=""
                              />{" "}
                            </div>
                          )}
                        </div>
                        {openServiceId ===
                          reservation?.serviceHeader?.ith_num &&
                          (servicesReservationFromPackage?.length > 0 ? (
                            <>
                              {servicesReservationFromPackage.map(
                                (service, serviceIndex) => (
                                  <div
                                    key={serviceIndex}
                                    className={`${styles.serviceBox}`}
                                    style={{ margin: "12px" }}
                                  >
                                    <div className="d-flex justify-content-between">
                                      <div className={styles.serviceTitle}>
                                        {isArabic
                                          ? service?.itd_itm_nam
                                          : service?.itd_itm_enm}
                                      </div>
                                      <div className="my-auto">
                                        <img
                                          id="serviceImg"
                                          onClick={() =>
                                            toggleShow({
                                              id: "service",
                                              img: "serviceImg",
                                            })
                                          }
                                          src={upArrow}
                                          alt=""
                                        />
                                      </div>
                                    </div>
                                    <hr color="rgba(209, 209, 209, 1)" />

                                    <div
                                      className={`${styles.serviceClass}`}
                                      id="service"
                                    >
                                      <BillLine
                                        text1={`${t("serviceProvider")} : ${
                                          isArabic
                                            ? service?.itd_emp_nam
                                            : service?.itd_emp_enam
                                        }`}
                                        text2={`${t("date")} : ${
                                          service?.itd_dat
                                        }`}
                                        styles={styles}
                                        myClass={"gap-5"}
                                      />
                                      <BillLine
                                        text1={`${t("branch")} : ${
                                          isArabic
                                            ? service?.brn_nam?.trim()
                                            : service?.brn_enm?.trim()
                                        }`}
                                        text2={`${t("time")} : ${
                                          service?.sevrce_time
                                        }`}
                                        styles={styles}
                                        myClass={"gap-5"}
                                      />
                                      <div
                                        className="d-flex justify-content-between my-3"
                                        style={{ gap: "10px" }}
                                      >
                                        <button
                                          className={styles.button}
                                          style={{
                                            width: "100%",
                                            background: (() => {
                                              const currentDate = new Date();
                                              currentDate.setHours(0, 0, 0, 0);

                                              const serviceDate = new Date(
                                                service?.itd_dat
                                              );
                                              currentDate.setHours(
                                                currentDate.getHours() +
                                                  Number(
                                                    settings?.expir_dat_for_edit?.trim()
                                                  )
                                              );

                                              return reservation
                                                ?.serviceHeaderDetails?.to_dat <
                                                formattedToDay ||
                                                serviceDate < currentDate
                                                ? "gray"
                                                : "";
                                            })(),
                                            cursor: (() => {
                                              const currentDate = new Date();
                                              const serviceDate = new Date(
                                                service?.itd_dat
                                              );
                                              currentDate.setHours(0, 0, 0, 0);
                                              currentDate.setHours(
                                                currentDate.getHours() +
                                                  Number(
                                                    settings?.expir_dat_for_edit?.trim()
                                                  )
                                              );

                                              return reservation
                                                ?.serviceHeaderDetails?.to_dat <
                                                formattedToDay ||
                                                serviceDate < currentDate
                                                ? "not-allowed"
                                                : "";
                                            })(),
                                          }}
                                          onClick={() => {
                                            const currentDate = new Date();
                                            const serviceDate = new Date(
                                              service?.itd_dat
                                            );
                                            currentDate.setHours(0, 0, 0, 0);

                                            currentDate.setHours(
                                              currentDate.getHours() +
                                                Number(
                                                  settings?.expir_dat_for_edit?.trim()
                                                )
                                            );
                                            console.log(
                                              "serviceDate",
                                              serviceDate
                                            );
                                            console.log(
                                              "currentDate",
                                              currentDate
                                            );

                                            // Check if the reservation is expired
                                            if (
                                              reservation?.serviceHeaderDetails
                                                ?.to_dat < formattedToDay
                                            ) {
                                              return notify(
                                                t("package_expired"),
                                                "error"
                                              );
                                            }
                                            // Check if the service is expired
                                            if (serviceDate < currentDate) {
                                              return notify(
                                                t("services_expired"),
                                                "error"
                                              );
                                            }

                                            console.log("service-->", service);

                                            navigate(
                                              "/ServiceProvidersForPackageServices",
                                              {
                                                state: {
                                                  isEdit: true,
                                                  header2:
                                                    reservation?.serviceHeaderDetails,
                                                  header:
                                                    reservation?.serviceHeader,
                                                  servicesId:
                                                    service?.itd_itmsrl,
                                                  servicesId2: service?.itd_num,
                                                  service: service,
                                                },
                                              }
                                            );
                                          }}
                                        >
                                          {t("Edit")}
                                        </button>

                                        {false && (
                                          <button
                                            className={styles.button}
                                            style={{
                                              width: "50%",
                                              background: (() => {
                                                const currentDate = new Date();
                                                const serviceDate = new Date(
                                                  service?.itd_dat
                                                );
                                                currentDate.setHours(
                                                  currentDate.getHours() -
                                                    Number(
                                                      settings?.expir_dat_for_edit?.trim()
                                                    )
                                                );

                                                return reservation
                                                  ?.serviceHeaderDetails
                                                  ?.to_dat < formattedToDay ||
                                                  serviceDate < currentDate
                                                  ? "gray"
                                                  : "";
                                              })(),
                                              cursor: (() => {
                                                const currentDate = new Date();
                                                const serviceDate = new Date(
                                                  service?.itd_dat
                                                );
                                                currentDate.setHours(
                                                  currentDate.getHours() -
                                                    Number(
                                                      settings?.expir_dat_for_edit?.trim()
                                                    )
                                                );

                                                return reservation
                                                  ?.serviceHeaderDetails
                                                  ?.to_dat < formattedToDay ||
                                                  serviceDate < currentDate
                                                  ? "not-allowed"
                                                  : "";
                                              })(),
                                            }}
                                            onClick={() => {
                                              const currentDate = new Date();
                                              const serviceDate = new Date(
                                                service?.itd_dat
                                              );
                                              currentDate.setHours(
                                                currentDate.getHours() -
                                                  Number(
                                                    settings?.expir_dat_for_edit?.trim()
                                                  )
                                              );
                                              console.log(
                                                "currentDate48hours",
                                                currentDate
                                              );

                                              // Check if the reservation is expired
                                              if (
                                                reservation
                                                  ?.serviceHeaderDetails
                                                  ?.to_dat < formattedToDay
                                              ) {
                                                return notify(
                                                  t("package_expired"),
                                                  "error"
                                                );
                                              }
                                              // Check if the service is expired
                                              if (serviceDate < currentDate) {
                                                return notify(
                                                  t("servicesCancelExpired"),
                                                  "error"
                                                );
                                              }
                                              setShowCancelModel(true);
                                            }}
                                          >
                                            {t("Cancel")}
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                )
                              )}
                            </>
                          ) : (
                            <>
                              {isLoading && (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Spinner
                                    animation="border"
                                    role="status"
                                    style={{ width: "50px", height: "50px" }}
                                  />
                                </div>
                              )}
                              {!isLoading && (
                                <div
                                  className="text-center fw-bold"
                                  style={{
                                    fontSize: "20px",
                                    color: "#555",
                                    margin: "10px",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  {t("noBookedServices")}
                                </div>
                              )}
                            </>
                          ))}
                      </div>
                    </>
                  )}

                  <BillLine
                    text1={t("paymentType")}
                    text2={
                      reservation?.serviceHeader?.ith_payM == 1
                        ? t("cash")
                        : t("online")
                    }
                    styles={styles}
                    myClass="m-3 justify-content-between flex-wrap"
                  />

                  <div
                    className={styles.submitContainer2}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      className={`${styles.button} d-flex justify-content-center align-items-center`}
                      disabled={PackageServicesLoading}
                      style={{
                        background:
                          reservation?.serviceHeaderDetails?.to_dat <
                          formattedToDay
                            ? "gray"
                            : "",
                        cursor:
                          reservation?.serviceHeaderDetails?.to_dat <
                          formattedToDay
                            ? "not-allowed"
                            : "",

                        width:
                          reservation?.serviceHeaderDetails?.max_stop_pack > 0
                            ? "50%"
                            : "100%",
                      }}
                      onClick={() => {
                        if (reservation?.serviceDetails?.length > 0) {
                          if (!PackageServicesLoading) {
                            console.log("reservation111", reservation);

                            if (
                              reservation?.serviceHeaderDetails?.to_dat <
                              formattedToDay
                            ) {
                              return notify(t("package_expired"), "error");
                            }
                            setIsLoadingStatic(index);
                            setHeader(reservation?.serviceHeader);
                            setHeader2(reservation?.serviceHeaderDetails);
                            openModal(
                              reservation?.serviceHeaderDetails?.itd_itmsrl
                            );
                          }
                        } else {
                          notify(t("no_services_available"), "error");
                        }
                      }}
                    >
                      {isLoadingStatic == index ? <Spinner /> : t("Book")}
                    </div>
                    {reservation?.serviceHeaderDetails?.max_stop_pack > 0 && (
                      <button
                        className={styles.button}
                        style={{
                          background:
                            reservation?.serviceHeaderDetails?.to_dat <
                            formattedToDay
                              ? "gray"
                              : "",
                          cursor:
                            reservation?.serviceHeaderDetails?.to_dat <
                            formattedToDay
                              ? "not-allowed"
                              : "",

                          width: "50%",
                        }}
                        onClick={async () => {
                          if (
                            reservation?.serviceHeaderDetails?.to_dat <
                            formattedToDay
                          ) {
                            return notify(t("package_expired"), "error");
                          }
                          setIsFroozingLoading(index);
                          setHeader2(reservation?.serviceHeaderDetails);
                          setHeader(reservation?.serviceHeader);
                          await dispatch(
                            getStoppedPackage({
                              id: reservation?.serviceHeaderDetails?.itd_num,
                            })
                          );
                          setIsFroozingLoading(null);
                          setStartFreezeTime("");
                          setEndFreezeTime("");
                          setFreezeNotes("");
                          setShowDetails(false);
                          setShowFreezeModel(true);
                        }}
                      >
                        {isFroozingLoading == index ? <Spinner /> : t("Freeze")}
                      </button>
                    )}
                  </div>

                  {/* <div className='d-flex justy-content-between'>

</div> */}
                </div>
              ))}
            </div>
          ) : (
            <div
              className="text-center fw-bold"
              style={{
                fontSize: "20px",
                color: "#555",
                margin: "10px",
                textTransform: "capitalize",
              }}
            >
              {t("noBookedPackages")}
            </div>
          )}
        </div>
      )}

      {/* Model */}
      <Modal
        show={isModalOpen}
        onHide={() => setIsModalOpen(false)}
        backdrop={true}
        dialogClassName="custom-modal"
      >
        <h2
          style={{
            textAlign: "center",
            marginBottom: "20px",
            marginTop: "10px",
          }}
        >
          {t("choose_service")}
        </h2>
        {loading ? (
          <div
            style={{
              width: "50%",
              margin: "auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {" "}
            <Spinner size={"100"} />{" "}
          </div>
        ) : (
          <div className={styles.DetailsComponant} style={{ border: "none" }}>
            <div className={styles.detailsContent}>
              {PackageServices?.map((el, index) => (
                <div
                  key={index}
                  className={styles.packagesServicesStyle}
                  onClick={async () => {
                    let data = {
                      packageNumber: header2?.itd_itmsrl,
                      packageSerial: header?.ith_num,
                      branchId: header?.ith_brn,
                    };

                    let response = await dispatch(
                      checkExpiredService({ id: el?.itd_itmsrl, data })
                    );
                    console.log("response", response?.payload?.status);
                    if (response?.payload?.status == true) {
                      navigate("/ServiceProvidersForPackageServices", {
                        state: {
                          selectedPackageService: el,
                          header2: header2,
                          header: header,
                          ServiceStatus: response,
                        },
                      });
                    } else if (response?.payload?.status == false) {
                      notify(t("service_usage_exceeded"), "error");
                    }
                  }}
                >
                  <div>{isArabic ? el?.itm_nam2 : el?.itm_enm2}</div>
                  <div
                    style={{
                      background: "#f6f6f6",
                      color: "#B49345",
                      borderRadius: "4px",
                      minWidth: "30px",
                      display: "flex",
                      justifyContent: "center",
                      fontSize: "18px",
                      fontWeight: "700",
                      height: "75%",
                      alignItems: "center",
                    }}
                  >
                    {el?.itd_totqty}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </Modal>

      <Modal
        show={showCancelModel}
        onHide={() => setShowCancelModel(false)}
        backdrop="static"
        dialogClassName="custom-modal"
      >
        <h2
          style={{
            textAlign: "center",
            marginBottom: "20px",
            marginTop: "10px",
          }}
        >
          {t("confirmServiceCancel")}
        </h2>

        <div
          className="modal-actions"
          style={{ display: "flex", justifyContent: "center", gap: "10px" }}
        >
          <Button
            onClick={() => {
              setShowCancelModel(false);
              notify(t("serviceCancelled"), "success");
            }}
            variant="danger"
          >
            {t("confirm")}
          </Button>

          <Button onClick={() => setShowCancelModel(false)} variant="secondary">
            {t("Cancel")}
          </Button>
        </div>
      </Modal>

      <Modal
        show={showFreezeModel}
        onHide={handleCloseModal}
        backdrop="static"
        dialogClassName="custom-modal large-modal"
      >
        <h2
          style={{
            textAlign: "center",
            marginBottom: "20px",
            marginTop: "10px",
            fontWeight: "700",
          }}
        >
          {stoppedPackage?.find((pkg) => pkg?.status === true)
            ? t("resumePackage")
            : t("confirmServiceFreeze")}
        </h2>

        {/* Tabs */}
        <div className="d-flex border-bottom mb-3 justify-content-around">
          <button
            className={`p-2 ${!showDetails ? "active-tab" : ""}`}
            onClick={() => setShowDetails(false)}
            style={{
              background: "none",
              border: "none",
              borderBottom: !showDetails ? "2px solid #B49345" : "none",
              fontWeight: !showDetails ? "600" : "400",
            }}
          >
            {t("packageDetails")}
          </button>
          <button
            className={`p-2 ${showDetails ? "active-tab" : ""}`}
            onClick={() => setShowDetails(true)}
            style={{
              background: "none",
              border: "none",
              borderBottom: showDetails ? "2px solid #B49345" : "none",
              fontWeight: showDetails ? "600" : "400",
            }}
          >
            {t("freezingHistory")}
          </button>
        </div>

        {!showDetails ? (
          <>
            {/* Package Details */}
            <div
              style={{
                padding: "0px 20px",
                textAlign: "start",
                fontSize: "16px",
              }}
            >
              <h4
                style={{
                  fontWeight: "600",
                  marginBottom: "10px",
                  textAlign: "center",
                }}
              ></h4>
              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  lineHeight: "2",
                }}
              >
                <li>
                  <span style={labelStyle}>{t("branchName")}:</span>
                  {isArabic ? header2?.brn_nam : header2?.brn_nam}
                </li>
                <li>
                  <span style={labelStyle}>{t("packageName")}:</span>
                  {isArabic ? header?.ith_pac_nam : header?.ith_pac_enm}
                </li>
                <li>
                  <span style={labelStyle}>{t("packageStartDate")}:</span>
                  {header2?.from_dat}
                </li>
                <li>
                  <span style={labelStyle}>{t("packageEndDate")}:</span>
                  {header2?.to_dat}
                </li>
                <li>
                  <span style={labelStyle}>{t("packageTime")}:</span>
                  {header2?.itm_dscnt} {t("Day")}
                </li>
              </ul>
            </div>

            {/* Freezing Time Inputs */}
            {!stoppedPackage?.find((pkg) => pkg?.status === true) && (
              <div className="d-flex flex-column gap-2 p-3">
                <label>{t("startFreezeTime")}</label>
                <input
                  type="date"
                  className="form-control"
                  value={startFreezeTime}
                  onChange={(e) => setStartFreezeTime(e.target.value)}
                  lang="en"
                  style={{
                    outline: "none",
                    boxShadow: "none",
                    border: "1px solid #ced4da",
                  }}
                />

                <label>{t("endFreezeTime")}</label>
                <input
                  type="date"
                  className="form-control"
                  value={endFreezeTime}
                  onChange={(e) => setEndFreezeTime(e.target.value)}
                  lang="en"
                  style={{
                    outline: "none",
                    boxShadow: "none",
                    border: "1px solid #ced4da",
                  }}
                />

                {/* Days of Freezing Calculation */}
                <label>{t("daysOfFreeze")}</label>
                <input
                  type="text"
                  className="form-control"
                  value={calculateDaysOfFreeze(startFreezeTime, endFreezeTime)}
                  readOnly
                  style={{
                    outline: "none",
                    boxShadow: "none",
                    border: "1px solid #ced4da",
                    background: "#f8f9fa",
                  }}
                />

                {/* Notes */}
                <label>{t("enterNotes")}</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("addNotes")}
                  value={freezeNotes}
                  onChange={(e) => setFreezeNotes(e.target.value)}
                  style={{
                    outline: "none",
                    boxShadow: "none",
                    border: "1px solid #ced4da",
                  }}
                />
              </div>
            )}

            {(() => {
              const lastActivePkg = [...(stoppedPackage || [])]
                .filter((pkg) => pkg.status === true)
                .pop();

              return lastActivePkg ? (
                <div
                  style={{
                    padding: "0px 20px",
                    textAlign: "start",
                    fontSize: "16px",
                  }}
                >
                  <ul
                    style={{
                      listStyle: "none",
                      padding: 0,
                      margin: 0,
                      lineHeight: "2",
                      fontSize: "16px",
                    }}
                  >
                    <li>
                      <span style={labelStyle}>{t("packageStartDate")}:</span>
                      {lastActivePkg.from_date}
                    </li>
                    <li>
                      <span style={labelStyle}>{t("packageEndDate")}:</span>
                      {lastActivePkg.to_date}
                    </li>
                    <li style={{ color: "#008000" }}>
                      <span style={{ ...labelStyle, color: "#008000" }}>
                        {t("packageDays")}:
                      </span>
                      {lastActivePkg.number_of_days} {t("Day")}
                    </li>
                    {lastActivePkg.notes && (
                      <li>
                        <span style={labelStyle}>{t("notes")}:</span>
                        {lastActivePkg.notes}
                      </li>
                    )}
                  </ul>
                </div>
              ) : null;
            })()}
            <div className="d-flex flex-column gap-2 px-3">
              <label
                style={{
                  fontWeight: "700",
                  color: "#000066",
                  marginTop: "15px",
                }}
              >
                {t("maxStop")} : <span>{Number(header2?.max_stop_pack)}</span>{" "}
                {t("day2")}{" "}
              </label>
              <label style={{ fontWeight: "700", color: "#000066" }}>
                {t("reminder")} :{" "}
                <span>
                  {Number(header2?.max_stop_pack) -
                    stoppedPackage?.reduce(
                      (sum, pkg) => sum + pkg.number_of_days,
                      0
                    ) || 0}{" "}
                </span>{" "}
                {t("day2")}
              </label>
            </div>
          </>
        ) : (
          <div>
            {/* <h4 style={{ fontWeight: "600", marginBottom: "15px" }}>{t("packageHistory")}</h4> */}
            <div className="table-responsive">
              {stoppedPackage && stoppedPackage?.length > 0 ? (
                <table className="table table-bordered">
                  <thead>
                    <tr
                      style={{
                        backgroundColor: "#f0f0f0",
                        "--bs-table-bg": "#f0f0f0", // Override Bootstrap CSS variable
                      }}
                    >
                      <th style={{ textAlign: "center" }}>{t("fromDate")}</th>
                      <th style={{ textAlign: "center" }}>{t("toDate")}</th>
                      <th style={{ textAlign: "center" }}>{t("daysCount")}</th>
                      <th style={{ textAlign: "center" }}>{t("status")}</th>
                      {/* <th style={{textAlign:"center"}}>{t("notes")}</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {stoppedPackage.map((pkg) => (
                      <tr key={pkg.serial_number}>
                        <td style={{ textAlign: "center" }}>{pkg.from_date}</td>
                        <td style={{ textAlign: "center" }}>{pkg.to_date}</td>
                        <td style={{ textAlign: "center" }}>
                          {pkg.number_of_days}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <span style={{ color: pkg.status ? "green" : "red" }}>
                            {pkg.status ? t("active") : t("inactive")}
                          </span>
                        </td>
                        {/* <td style={{textAlign:"center"}}>{pkg.notes}</td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    margin: "20px 0",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px",
                    border: "1px dashed #ddd",
                    color: "#6c757d",
                    fontSize: "16px",
                  }}
                >
                  {t("thereIsNoFreezingHistoryForThisPackage")}
                </div>
              )}
            </div>
          </div>
        )}

        {/* Action Buttons - Always visible */}
        {isLoadingStop ? (
          <Spinner />
        ) : (
          <div
            className="modal-actions"
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "10px",
              marginTop: "20px",
            }}
          >
            {!showDetails &&
              (stoppedPackage?.length === 0 ||
                !stoppedPackage?.find((pkg) => pkg?.status === true)) && (
                <Button
                  onClick={() => {
                    stopPackageSubmit();
                  }}
                  style={{ background: "#B49345", border: "1px solid #B49345" }}
                >
                  {t("stop")}
                </Button>
              )}

            {stoppedPackage?.find((pkg) => pkg?.status === true) && (
              <Button
                onClick={() => {
                  // stopPackageSubmit();
                  resumePackageSubmit();
                }}
                style={{ background: "#B49345", border: "1px solid #B49345" }}
              >
                {t("Resume")}
              </Button>
            )}

            <Button
              onClick={() => setShowFreezeModel(false)}
              variant="secondary"
            >
              {t("Cancel")}
            </Button>
          </div>
        )}
      </Modal>
    </>
  );
}
